﻿$.fn.dxCtrlSuiviTraitementEmailServeurReception = function custom_dxCtrlSuiviTraitementEmailServeurReception(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsuivitraitementemailserveurreception dx-ctrl");
        this.createInstance(new cdxCtrlSuiviTraitementEmailServeurReception(this, option));
    }
    return this;
}

window.cdxCtrlSuiviTraitementEmailServeurReception = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    option.bddCtrl.mAddFunctionOnModifiedItemData(["compte_email"], container,
        function (action, itemData) {
            if (!itemData || itemData.id_compte_email == option.dataCompteEmail.id_compte_email) {
                Me.mUpdataData()
            }
        })

    //option.dataCompteEmail
    //option.container
    var progressBar = null
    var $TdStatut = null
    function mConstruit() {
        container.empty()

        var $TableJauge = $("<table style='width:100%;font-size:90%;'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($TableJauge)
        var $Td = $("<td style='width:0px;'><img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:17px;display:block'/></td>").appendTo($Tr)
        var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        progressBar = $("<div/>").appendTo($Td).dxProgressBar({
            min: 0,
            max: 1,
            value: 0,
            width: "100%",
            showStatus: false
        }).dxProgressBar("instance");
        $TdStatut = $("<td style='width:1px;white-space:nowrap;font-family:barlow condensed;'>0/0&bull;0%</td>").appendTo($Tr)

        Me.mUpdataData()
    }

    this.mUpdataData = function () {
        if (option.container.closest("body").length == 0) return
        if (option.dataCompteEmail.reception_actif == "0" || option.dataCompteEmail.nb_email_total_to_load == null || option.dataCompteEmail.nb_email_total_to_load<50) {
            option.container.hide()
        } else {
            option.container.show()
            progressBar.option({
                max: parseInt(option.dataCompteEmail.nb_email_total_to_load),
                value: parseInt(option.dataCompteEmail.nb_email_loaded)
            })
            $TdStatut.html(option.dataCompteEmail.nb_email_loaded + "<span style='opacity:0.3;'>/</span>" + option.dataCompteEmail.nb_email_total_to_load + "<span style='opacity:0.3;'>&bull;</span>" + parseInt(option.dataCompteEmail.nb_email_loaded / option.dataCompteEmail.nb_email_total_to_load * 100) + "%")
        }

        if ((option.dataCompteEmail.reception_actif == "1" && option.dataCompteEmail.nb_email_total_to_load != null && option.dataCompteEmail.nb_email_total_to_load > 30) ||
            Math.abs(diffdate(option.dataCompteEmail.dmo, parametre.dateNow, "s")) < 2000) {
            window.setTimeout(function () {
                option.bddCtrl.mReloadItem(option.dataCompteEmail, function () {
                    Me.mUpdataData()
                })
            }, ((option.dataCompteEmail.nb_email_total_to_load != null && option.dataCompteEmail.nb_email_total_to_load > 30) ? 4000 : 10000))
        } else {

        }
    }

    this.element = function () { return container }

    mConstruit();
}